<template>
  <v-list nav class="text-uppercase text-decoration-none" style="padding-top: 225px">
    <v-list-item
      v-for="(item, index) in routes"
      :key="index"
      class="text-decoration-none"
      @click="routeHandler(item.name)"
    >
        <span :class="classLink">{{item.text}}</span>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "Menu",
  data() {
    return {
      routes: [
        {name: 'Home', text: 'Главная'},
        {name: 'About', text: 'Обо мне'},
        {name: 'Record', text: 'Записаться на консультацию'},
        {name: 'Contact', text: 'Контакты'},
      ],
    }
  },
  computed: {
    classLink() {
      return {
        'link': true,
        'font-desktop': !this.$vuetify.breakpoint.smAndDown,
        'font-mobile': this.$vuetify.breakpoint.smAndDown,
        'ml-auto': true
      }
    }
  },
  methods: {
    closeDrawer() {
      this.$emit('closeDrawer');
    },
    routeHandler(route) {
      this.$router.push({name: route});
      this.closeDrawer();
    }
  },
}
</script>

<style scoped>
.link {
  color: #FEFEFE;
}
.font-desktop {
  font-size: calc(24px);
}
.font-mobile {
  font-size: calc(19px);
}
</style>
